import { render, staticRenderFns } from "./articleEntry.vue?vue&type=template&id=070384a3&scoped=true&"
import script from "./articleEntry.vue?vue&type=script&lang=js&"
export * from "./articleEntry.vue?vue&type=script&lang=js&"
import style0 from "./articleEntry.vue?vue&type=style&index=0&id=070384a3&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070384a3",
  null
  
)

export default component.exports